import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Map, Layers } from 'lucide-react';
import { StatCard, WidgetPanel } from './DashboardShared';
import { zonesOf, branchesOf } from '../../../data/store';

export const ZoneModule = ({ org }) => {
  const metrics = useMemo(() => {
    const zones = zonesOf(org.id);
    const branches = branchesOf(org.id);

    const branchesPerZone = {};
    zones.forEach(z => {
      branchesPerZone[z.id] = { name: z.name, count: 0, id: z.id };
    });

    branches.forEach(b => {
      if (b.zoneId && branchesPerZone[b.zoneId]) {
        branchesPerZone[b.zoneId].count++;
      }
    });
    
    return { totalZones: zones.length, branchesPerZone: Object.values(branchesPerZone) };
  }, [org.id]);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-2 text-[13px] font-bold uppercase tracking-[0.15em] text-[#0d0d0d] border-b border-slate-100 pb-3 mt-4">
        <Map size={16} className="text-[var(--theme-primary)]" />
        Zone Management
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Map} label="Total Zones" value={metrics.totalZones} iconColor="#ec4899" />
      </div>

      <div className="grid grid-cols-1 gap-6">
        <WidgetPanel title="Branches per Zone">
           <ul className="divide-y divide-slate-100">
              {metrics.branchesPerZone.length === 0 && <li className="py-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-slate-300">No zones configured</li>}
              {metrics.branchesPerZone.map((z, idx) => (
                <li key={idx} className="py-3 flex items-center justify-between text-xs">
                  <div className="flex items-center gap-3">
                    <span className="w-8 h-8 rounded-xl bg-pink-50 flex items-center justify-center text-pink-500">
                      <Layers size={14} />
                    </span>
                    <span className="font-bold text-slate-700 truncate">{z.name}</span>
                  </div>
                  <span className="font-bold text-slate-800 bg-slate-100 px-3 py-1 rounded-lg">{z.count}</span>
                </li>
              ))}
           </ul>
        </WidgetPanel>
      </div>
    </div>
  );
};

ZoneModule.propTypes = {
  org: PropTypes.object.isRequired,
};
